module.exports = __webpack_public_path__ + "img/github-icon.d4c053fe.svg";